import { render, staticRenderFns } from "./downDirective.vue?vue&type=template&id=710e4716&scoped=true&"
import script from "./downDirective.vue?vue&type=script&lang=js&"
export * from "./downDirective.vue?vue&type=script&lang=js&"
import style0 from "./downDirective.vue?vue&type=style&index=0&id=710e4716&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710e4716",
  null
  
)

export default component.exports